(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1233],{

/***/ 28856:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help",
      function () {
        return __webpack_require__(93802);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ help; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./layout/Layout/index.js + 9 modules
var Layout = __webpack_require__(4967);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-i18next@13.0.2_i18next@22.4.6_next@12.3.4_react-i18next@12.1.1_react@18.2.0/node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(66264);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(57135);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59072);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.4.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(80677);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/router.js
var next_router = __webpack_require__(63498);
// EXTERNAL MODULE: ./components/FormElements/SimpleTextBox.js
var SimpleTextBox = __webpack_require__(53909);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./services/allServices.js + 1 modules
var allServices = __webpack_require__(63700);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/link.js
var next_link = __webpack_require__(13786);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./store/GlobalStore.js
var GlobalStore = __webpack_require__(36345);
;// CONCATENATED MODULE: ./components/Help/SearchInput.js











var SearchInput = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "help"
    ]).t;
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,GlobalStore/* useGlobalStore */.s)(function(state) {
        return [
            state.setSearchArticleWiki
        ];
    }), 1), setSearchArticleWiki = ref[0];
    var ref1 = (0,react.useState)(""), searchValue = ref1[0], setSearchValue = ref1[1];
    var ref2 = (0,react.useState)([]), searchResult = ref2[0], setSearchResult = ref2[1];
    var handleSearch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var params;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(searchValue.length >= 3)) return [
                            3,
                            2
                        ];
                        params = {
                            search: searchValue,
                            language_id: router.locale === "tr" ? 1 : 2
                        };
                        return [
                            4,
                            (0,allServices/* searchArticleHelp */.M7)(params).then(function(res) {
                                setSearchResult(res.categories);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setSearchResult([]);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSearch() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleKeyDown = function(event) {
        if (event.key === "Enter") {
            handleSearch();
        } else if (event.key === "Backspace" && searchValue.length === 0) {
            setSearchResult([]);
        }
    };
    var handleOnChange = function(value) {
        setSearchValue(value);
        if (value.length === 0) {
            setSearchResult([]);
        } else if (value.length >= 3) {
            handleSearch();
        }
    };
    var handleSetSearchArticle = function(articles) {
        setSearchArticleWiki(articles);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex pt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTextBox/* default */.Z, {
                        value: searchValue,
                        onChange: handleOnChange,
                        inputName: "search",
                        placeholder: t("help:search"),
                        onKeyDown: handleKeyDown,
                        isHelp: true,
                        searchResult: searchResult
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "".concat(searchResult.length > 0 ? "rounded-tr-2xl" : "rounded-r-2xl", "  h-[39px] mt-6 lg:mt-1 -ml-4 lg:-ml-8 p-4 text-lg flex items-center text-white bg-black"),
                        onClick: function() {
                            return handleSearch();
                        },
                        children: [
                            t("help:search"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "ml-3 text-2xl ri-search-line"
                            })
                        ]
                    })
                ]
            }),
            searchResult.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-4 border-b border-l border-r rounded-b-md bg-gray-50 border-makdosYellow",
                children: searchResult.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(router.locale === "tr" ? "/yardim" : "/help", "/").concat(item === null || item === void 0 ? void 0 : item.category_slug, "/").concat(router.locale === "tr" ? "arama" : "search", "?q=").concat(searchValue),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "p-3 border-b cursor-pointer hover:underline text-textGray hover:text-black",
                            onClick: function() {
                                return handleSetSearchArticle(item === null || item === void 0 ? void 0 : item.articles);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    item === null || item === void 0 ? void 0 : item.category_title,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "(",
                                            item === null || item === void 0 ? void 0 : item.category_total_count,
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var Help_SearchInput = (SearchInput);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/image.js
var next_image = __webpack_require__(70649);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/Help/MainCategories.js



var MainCategories = function(param) {
    var categories = param.categories, locale = param.locale;
    var defaultNoImage = "/noImageWiki.png";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid lg:grid-cols-3 gap-x-4 gap-y-8",
                children: categories === null || categories === void 0 ? void 0 : categories.slice(0, 6).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/".concat(locale === "tr" ? "yardim" : "help", "/").concat(item.slug),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-4 space-y-4 border border-black cursor-pointer rounded-2xl",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: item.img ? "https://api-web.makdos.com/" + item.img : defaultNoImage,
                                        title: item.image_title,
                                        alt: item.image_description,
                                        width: 245,
                                        height: 155,
                                        quality: 100,
                                        onError: function(param) {
                                            var currentTarget = param.currentTarget;
                                            currentTarget.onerror = null;
                                            currentTarget.src = defaultNoImage;
                                            currentTarget.srcset = defaultNoImage;
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-lg font-semibold text-black",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-black",
                                    children: item.description
                                })
                            ]
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 gap-4 pt-8",
                children: categories.slice(6, 8).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-4 space-y-4 border border-black cursor-pointer rounded-2xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: item.img ? "https://api-web.makdos.com/" + item.img : defaultNoImage,
                                    title: item.image_title,
                                    alt: item.image_description,
                                    width: 245,
                                    height: 155,
                                    onError: function(param) {
                                        var currentTarget = param.currentTarget;
                                        currentTarget.onerror = null;
                                        currentTarget.src = defaultNoImage;
                                        currentTarget.srcset = defaultNoImage;
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-lg font-semibold text-black",
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-black",
                                children: item.description
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var Help_MainCategories = (MainCategories);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/head.js
var head = __webpack_require__(93834);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/help/index.js






var index = function(param) {
    var categories = param.categories, locale = param.locale;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "nav",
        "help"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("common:helpMetaTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("common:helpMetaDescription")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: t("common:helpMetaTitle")
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: t("common:helpMetaDescription")
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://makdos.com/headerLogo.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-10 bg-makdosSecondaryGray",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container p-5 mx-auto bg-white rounded-md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-3xl font-semibold text-black",
                            children: t("help:welcomeHelp")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "pt-3 text-lg text-textGray",
                            children: t("help:welcomeHelpDescription")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Help_SearchInput, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pt-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help_MainCategories, {
                                categories: categories,
                                locale: locale
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var help = (index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2658,4967,9774,2888,179], function() { return __webpack_exec__(28856); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);